module.exports = __webpack_public_path__ + "static/media/logo_company_login.9b3f257b.png";